import React from "react";
import { Dropdown } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { SORT_BY } from "../shadowingsFilter/sort_options";
import { HasRole } from "../../app/helpers/userHelpers";
import { UserRoles } from "../../app/auth/roles";

interface Props {
  sortBy: SORT_BY;
  onSortChange: (value: SORT_BY) => void;

  text?: string;
  icon?: any;
}

const ExcursionSorter = ({ text, icon, onSortChange, sortBy }: Props) => {
  const { t } = useTranslation();
  const isAdmin = HasRole(UserRoles.admin);

  const options = [
    {
      key: "nearest",
      text: <h4>{t("common.sort_by.nearest")}</h4>,
      value: SORT_BY.nearestFirst,
      content: t("common.sort_by.nearest"),
    },
    {
      key: "furthest",
      text: <h4>{t("common.sort_by.furthest")}</h4>,
      value: SORT_BY.furthestFirst,
      content: t("common.sort_by.furthest"),
    },
    ...(isAdmin
      ? [
          {
            key: "newest",
            text: <h4>{t("common.sort_by.newest")}</h4>,
            value: "createdOn_desc",
            content: t("common.sort_by.newest"),
          },
          {
            key: "oldest",
            text: <h4>{t("common.sort_by.oldest")}</h4>,
            value: "createdOn_asc",
            content: t("common.sort_by.oldest"),
          },
        ]
      : []),
  ];

  const handleChange = (_: any, { value }: any) => {
    onSortChange(value);
  };

  return (
    <div className="shadowing-sorter">
      <Dropdown icon={icon} text={text} options={options} value={sortBy} onChange={handleChange} />
    </div>
  );
};

export default ExcursionSorter;
